module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- build-targets/portal/packages/core-app/src/templates/appModalCrumbView.html -->\n<div class="nx-action" data-action="app:remove:modalView">\n    '+
((__t=( icons.faTimes ))==null?'':__t)+
'\n</div>\n<a class="nx-action" data-action="'+
((__t=( action ))==null?'':__t)+
'">\n    <span class="text" data-nx-control="title">'+
((__t=( label ))==null?'':__t)+
'</span>\n</a>\n';
}
return __p;
};
